// Block.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const useBlockBackNavigation = (callback) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.history.pushState(null, "", window.location.pathname);

    const handlePopState = (e) => {
      e.preventDefault();
      callback();
      window.history.pushState(null, "", location.pathname); // bloqueia o voltar real
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [callback, location.pathname]);
};

export default useBlockBackNavigation;
